const reportTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "pb-0"
            },
            "tag": "h4",
            "parent": 4,
            "html": "Monitoring Report"
        },
        "6": {
            "config": {
                "class": "row",
                "id": "monitoring_vista"
            },
            "tag": "div",
            "parent": 2,
            "html": ""
        },
        "7": {
            "config": {
                "class": "col-12",
            },
            "tag": "div",
            "parent": 6,
            "html": ""
        },
        "8": {
            "config": {
                "class": "card p-0",
            },
            "tag": "div",
            "parent": 7
        },
        "9": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 8
        },
        "10": {
            "config": {
                "class": "data-wrap-fixed row m-0 shadowNone vista-header"
            },
            "tag": "div",
            "parent": 9,
            "html": ""
        },
        "11": {
            "config": {
                "class": "data-wrap-fixed row m-0 shadowNone vista-rows"
            },
            "tag": "div",
            "parent": 9
        },
        "12": {
            "config": {
                "class": "col-1 dataLeft-fixed dataLeft-fixed-monitoring0 p-0"
            },
            "tag": "div",
            "parent": 11,
            "html": ""
        },
        "13": {
            "config": {
                "class": "col-2 dataLeft-fixed dataLeft-fixed-monitoring1 pane p-0"
            },
            "tag": "div",
            "parent": 11,
            "html": ""
        },
        "14": {
            "config": {
                "class": "col-2 dataLeft-fixed dataLeft-fixed-monitoring2 pane p-0"
            },
            "tag": "div",
            "parent": 11,
            "html": ""
        },
        "15": {
            "config": {
                "class": "col-1 dataLeft-fixed dataLeft-fixed-monitoring3 pane p-0"
            },
            "tag": "div",
            "parent": 11,
            "html": ""
        },
        "16": {
            "config": {
                "class": "col-1 dataLeft-fixed dataLeft-fixed-monitoring4 pane p-0"
            },
            "tag": "div",
            "parent": 11,
            "html": ""
        },
        "17": {
            "config": {
                "class": "col-5 p-0 variable-header-monitoring"
            },
            "tag": "div",
            "parent": 11
        },
        "18": {
            "config": {
                "id": "monitoring_rows",
                "class": "mid-panel  mid-panel-monitoring"
            },
            "tag": "div",
            "parent": 17
        },
        "19": {
            "config": {
                "class": "data-head data-head-monitoring"
            },
            "tag": "div",
            "parent": 18,
            "html": ""
        },
        "20": {
            "config": {
                "class": "col-7 dataLeft-fixed p-0 shrinkExpandLegends"
            },
            "tag": "div",
            "parent": 10,
            "html": ""
        },
        "21": {
            "config": {
                "class": "col-5 variable-header-monitoring p-0",
                "style": {
                    "height": "60px",
                    "overflow": "hidden"
                }
            },
            "tag": "div",
            "parent": 10,
            "html": ""
        },
        "22": {
            "config": {
                "class": "mid-panel mid-panel-funded",
                "id": "pre-funded-monitoring-labels"
            },
            "tag": "div",
            "parent": 21,
            "html": ""
        },
        "23": {
            "config": {
                "class": "data-head data-head-funded",
                "id": "pre-funded"
            },
            "tag": "div",
            "parent": 22,
            "html": ""
        },
        "24": {
            "config": {
                "class": "funding-legends-date",
                "id": "funding_legends_date"
            },
            "tag": "div",
            "parent": 20,
            "html": ""
        }
    }
    return {
        main
    };
})();